module.exports = __webpack_public_path__ + "img/weiwendi.9fe85acc.png";